RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Companies = window.createMarionetteApp();
    app.name = 'Companies';
});
